import { Subject, Observable, of } from "rxjs";
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'app/core/services/configuration.service';
import { catchError } from "rxjs/operators";
import { NotifMessageService } from "./notifmessage.service";
import { Items } from "../models/items";
import { PointOfService } from "../models/pointOfService";

@Injectable({ providedIn: 'root' })
export class PosService {

    isSaveNeeded: boolean = false;

    constructor(
        private http: HttpClient,
        private configService: ConfigurationService,
        private notifService: NotifMessageService
    ) { }


    saveSubject = new Subject<any[]>();

    searchSubject = new Subject<any[]>();

    posSubjectPager = new Subject<any[]>();

    emitSaveNeeded() {
        this.isSaveNeeded = true;
        this.saveSubject.next([this.isSaveNeeded]);
    }

    emitCriteria(criteria) {
        this.searchSubject.next(criteria);
    }

    emitPosPager(pos) {
        this.posSubjectPager.next(pos);
    }

    // API POS calls

    getPosTotalElement(): Observable<Items<PointOfService>> {
        let pager = { page: 1, size: 0, sort: "id,ASC" };
        return this.findByCriteria({}, pager, false);
    }

    findByCriteria(criteria, pager, isDeletedIncluded:boolean): Observable<Items<PointOfService>> {
        let params = {};
        Object.assign(params, pager, criteria, {includeDeleted:isDeletedIncluded});

        return this.http.get<Items<PointOfService>>(this.configService.config.urlAPI.urlPOS, { params: params }).pipe(catchError(err => {
            this.notifService.notifyErrorWithDetailFromApi('ERROR_POS_API', err);
            let emptyList = new Items<PointOfService>();
            emptyList.content = [];
            return of(emptyList);
        }));
    }

    getPosById(id): Observable<PointOfService> {
        return this.http.get<PointOfService>(`${this.configService.config.urlAPI.urlPOS}/${id}`).pipe(catchError(err => {
            if (err.status == "404") {
                console.log("error", err);
            } else {
                this.notifService.notifyErrorWithDetailFromApi('ERROR_POS_API', err);
            }
            let emptyItem = new PointOfService();
            emptyItem.name = "N/A";
            return of(emptyItem);
        }));
    }

    getPosByIdForReport(id): Observable<PointOfService> {
        console.log("get pos by id");
        return this.http.get<PointOfService>(`${this.configService.config.urlAPI.urlPOS}/${id}`).pipe(catchError(err => {
            return of(null);
        }));
    }
    deletePos(id): Observable<PointOfService> {
        return this.http.delete<PointOfService>(`${this.configService.config.urlAPI.urlPOS}/${id}`).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_POS_API', err);
            return of(null);
        }));
    }

    updatePos(pos): Observable<PointOfService> {
        return this.http.put<any>(this.configService.config.urlAPI.urlPOS, pos).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_POS_API', err);
            return of(null);
        }));
    }

    createPosAPI(newPos): Observable<PointOfService> {
        return this.http.post<any>(this.configService.config.urlAPI.urlPOS, newPos).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_POS_API', err);
            return of(null);
        }));
    }

    toURL(obj): string {

        let res = "";

        for (let [key, val] of Object.entries(obj)) {
            if (typeof obj[key] !== "object") {
                res === "" ? res += `${key}=${val}` : res += `&${key}=${val}`;
            }
            else {
                res += this.toURL(obj[key]).split("&").map(el => key + "." + el).join('&');
            }
        }

        return res;
    }
}
